export const countries = [
  {
    codigo: 'HN',
    telefonos: ['+504'],
    nombre: 'Honduras',
    bandera: 'https://flagcdn.com/w320/hn.png',
  },
  {
    codigo: 'GT',
    telefonos: ['+502'],
    nombre: 'Guatemala',
    bandera: 'https://flagcdn.com/w320/gt.png',
  },
  {
    codigo: 'SV',
    telefonos: ['+503'],
    nombre: 'El Salvador',
    bandera: 'https://flagcdn.com/w320/sv.png',
  },
  {
    codigo: 'PA',
    telefonos: ['+507'],
    nombre: 'Panama',
    bandera: 'https://flagcdn.com/w320/pa.png',
  },
  {
    codigo: 'CR',
    telefonos: ['+506'],
    nombre: 'Costa Rica',
    bandera: 'https://flagcdn.com/w320/cr.png',
  },
  {
    codigo: 'MD',
    telefonos: ['+373'],
    nombre: 'Moldova',
    bandera: 'https://flagcdn.com/w320/md.png',
  },
  {
    codigo: 'KM',
    telefonos: ['+269'],
    nombre: 'Comoros',
    bandera: 'https://flagcdn.com/w320/km.png',
  },
  {
    codigo: 'MY',
    telefonos: ['+60'],
    nombre: 'Malaysia',
    bandera: 'https://flagcdn.com/w320/my.png',
  },
  {
    codigo: 'DZ',
    telefonos: ['+213'],
    nombre: 'Algeria',
    bandera: 'https://flagcdn.com/w320/dz.png',
  },
  {
    codigo: 'SI',
    telefonos: ['+386'],
    nombre: 'Slovenia',
    bandera: 'https://flagcdn.com/w320/si.png',
  },
  {
    codigo: 'GY',
    telefonos: ['+592'],
    nombre: 'Guyana',
    bandera: 'https://flagcdn.com/w320/gy.png',
  },
  {
    codigo: 'FR',
    telefonos: ['+33'],
    nombre: 'France',
    bandera: 'https://flagcdn.com/w320/fr.png',
  },
  {
    codigo: 'DK',
    telefonos: ['+45'],
    nombre: 'Denmark',
    bandera: 'https://flagcdn.com/w320/dk.png',
  },
  {
    codigo: 'KZ',
    telefonos: ['+76', '+77'],
    nombre: 'Kazakhstan',
    bandera: 'https://flagcdn.com/w320/kz.png',
  },
  {
    codigo: 'VU',
    telefonos: ['+678'],
    nombre: 'Vanuatu',
    bandera: 'https://flagcdn.com/w320/vu.png',
  },
  {
    codigo: 'UA',
    telefonos: ['+380'],
    nombre: 'Ukraine',
    bandera: 'https://flagcdn.com/w320/ua.png',
  },
  {
    codigo: 'LI',
    telefonos: ['+423'],
    nombre: 'Liechtenstein',
    bandera: 'https://flagcdn.com/w320/li.png',
  },
  {
    codigo: 'AT',
    telefonos: ['+43'],
    nombre: 'Austria',
    bandera: 'https://flagcdn.com/w320/at.png',
  },
  {
    codigo: 'KW',
    telefonos: ['+965'],
    nombre: 'Kuwait',
    bandera: 'https://flagcdn.com/w320/kw.png',
  },
  {
    codigo: 'AD',
    telefonos: ['+376'],
    nombre: 'Andorra',
    bandera: 'https://flagcdn.com/w320/ad.png',
  },
  {
    codigo: 'BW',
    telefonos: ['+267'],
    nombre: 'Botswana',
    bandera: 'https://flagcdn.com/w320/bw.png',
  },
  {
    codigo: 'AE',
    telefonos: ['+971'],
    nombre: 'United Arab Emirates',
    bandera: 'https://flagcdn.com/w320/ae.png',
  },
  {
    codigo: 'CM',
    telefonos: ['+237'],
    nombre: 'Cameroon',
    bandera: 'https://flagcdn.com/w320/cm.png',
  },
  {
    codigo: 'RU',
    telefonos: ['+73', '+74', '+75', '+78', '+79'],
    nombre: 'Russia',
    bandera: 'https://flagcdn.com/w320/ru.png',
  },
  {
    codigo: 'JM',
    telefonos: ['+1876', '+1658'],
    nombre: 'Jamaica',
    bandera: 'https://flagcdn.com/w320/jm.png',
  },
  {
    codigo: 'DJ',
    telefonos: ['+253'],
    nombre: 'Djibouti',
    bandera: 'https://flagcdn.com/w320/dj.png',
  },
  {
    codigo: 'KE',
    telefonos: ['+254'],
    nombre: 'Kenya',
    bandera: 'https://flagcdn.com/w320/ke.png',
  },
  {
    codigo: 'BZ',
    telefonos: ['+501'],
    nombre: 'Belize',
    bandera: 'https://flagcdn.com/w320/bz.png',
  },
  {
    codigo: 'MM',
    telefonos: ['+95'],
    nombre: 'Myanmar',
    bandera: 'https://flagcdn.com/w320/mm.png',
  },
  {
    codigo: 'SG',
    telefonos: ['+65'],
    nombre: 'Singapore',
    bandera: 'https://flagcdn.com/w320/sg.png',
  },
  {
    codigo: 'SK',
    telefonos: ['+421'],
    nombre: 'Slovakia',
    bandera: 'https://flagcdn.com/w320/sk.png',
  },
  {
    codigo: 'IS',
    telefonos: ['+354'],
    nombre: 'Iceland',
    bandera: 'https://flagcdn.com/w320/is.png',
  },
  {
    codigo: 'BT',
    telefonos: ['+975'],
    nombre: 'Bhutan',
    bandera: 'https://flagcdn.com/w320/bt.png',
  },
  {
    codigo: 'MK',
    telefonos: ['+389'],
    nombre: 'North Macedonia',
    bandera: 'https://flagcdn.com/w320/mk.png',
  },
  {
    codigo: 'GN',
    telefonos: ['+224'],
    nombre: 'Guinea',
    bandera: 'https://flagcdn.com/w320/gn.png',
  },
  {
    codigo: 'MT',
    telefonos: ['+356'],
    nombre: 'Malta',
    bandera: 'https://flagcdn.com/w320/mt.png',
  },
  {
    codigo: 'AF',
    telefonos: ['+93'],
    nombre: 'Afghanistan',
    bandera:
      'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_the_Taliban.svg/320px-Flag_of_the_Taliban.svg.png',
  },
  {
    codigo: 'US',
    telefonos: [
      '+1201',
      '+1202',
      '+1203',
      '+1205',
      '+1206',
      '+1207',
      '+1208',
      '+1209',
      '+1210',
      '+1212',
      '+1213',
      '+1214',
      '+1215',
      '+1216',
      '+1217',
      '+1218',
      '+1219',
      '+1220',
      '+1224',
      '+1225',
      '+1227',
      '+1228',
      '+1229',
      '+1231',
      '+1234',
      '+1239',
      '+1240',
      '+1248',
      '+1251',
      '+1252',
      '+1253',
      '+1254',
      '+1256',
      '+1260',
      '+1262',
      '+1267',
      '+1269',
      '+1270',
      '+1272',
      '+1274',
      '+1276',
      '+1281',
      '+1283',
      '+1301',
      '+1302',
      '+1303',
      '+1304',
      '+1305',
      '+1307',
      '+1308',
      '+1309',
      '+1310',
      '+1312',
      '+1313',
      '+1314',
      '+1315',
      '+1316',
      '+1317',
      '+1318',
      '+1319',
      '+1320',
      '+1321',
      '+1323',
      '+1325',
      '+1327',
      '+1330',
      '+1331',
      '+1334',
      '+1336',
      '+1337',
      '+1339',
      '+1346',
      '+1347',
      '+1351',
      '+1352',
      '+1360',
      '+1361',
      '+1364',
      '+1380',
      '+1385',
      '+1386',
      '+1401',
      '+1402',
      '+1404',
      '+1405',
      '+1406',
      '+1407',
      '+1408',
      '+1409',
      '+1410',
      '+1412',
      '+1413',
      '+1414',
      '+1415',
      '+1417',
      '+1419',
      '+1423',
      '+1424',
      '+1425',
      '+1430',
      '+1432',
      '+1434',
      '+1435',
      '+1440',
      '+1442',
      '+1443',
      '+1447',
      '+1458',
      '+1463',
      '+1464',
      '+1469',
      '+1470',
      '+1475',
      '+1478',
      '+1479',
      '+1480',
      '+1484',
      '+1501',
      '+1502',
      '+1503',
      '+1504',
      '+1505',
      '+1507',
      '+1508',
      '+1509',
      '+1510',
      '+1512',
      '+1513',
      '+1515',
      '+1516',
      '+1517',
      '+1518',
      '+1520',
      '+1530',
      '+1531',
      '+1534',
      '+1539',
      '+1540',
      '+1541',
      '+1551',
      '+1559',
      '+1561',
      '+1562',
      '+1563',
      '+1564',
      '+1567',
      '+1570',
      '+1571',
      '+1573',
      '+1574',
      '+1575',
      '+1580',
      '+1585',
      '+1586',
      '+1601',
      '+1602',
      '+1603',
      '+1605',
      '+1606',
      '+1607',
      '+1608',
      '+1609',
      '+1610',
      '+1612',
      '+1614',
      '+1615',
      '+1616',
      '+1617',
      '+1618',
      '+1619',
      '+1620',
      '+1623',
      '+1626',
      '+1628',
      '+1629',
      '+1630',
      '+1631',
      '+1636',
      '+1641',
      '+1646',
      '+1650',
      '+1651',
      '+1657',
      '+1660',
      '+1661',
      '+1662',
      '+1667',
      '+1669',
      '+1678',
      '+1681',
      '+1682',
      '+1701',
      '+1702',
      '+1703',
      '+1704',
      '+1706',
      '+1707',
      '+1708',
      '+1712',
      '+1713',
      '+1714',
      '+1715',
      '+1716',
      '+1717',
      '+1718',
      '+1719',
      '+1720',
      '+1724',
      '+1725',
      '+1727',
      '+1730',
      '+1731',
      '+1732',
      '+1734',
      '+1737',
      '+1740',
      '+1743',
      '+1747',
      '+1754',
      '+1757',
      '+1760',
      '+1762',
      '+1763',
      '+1765',
      '+1769',
      '+1770',
      '+1772',
      '+1773',
      '+1774',
      '+1775',
      '+1779',
      '+1781',
      '+1785',
      '+1786',
      '+1801',
      '+1802',
      '+1803',
      '+1804',
      '+1805',
      '+1806',
      '+1808',
      '+1810',
      '+1812',
      '+1813',
      '+1814',
      '+1815',
      '+1816',
      '+1817',
      '+1818',
      '+1828',
      '+1830',
      '+1831',
      '+1832',
      '+1843',
      '+1845',
      '+1847',
      '+1848',
      '+1850',
      '+1854',
      '+1856',
      '+1857',
      '+1858',
      '+1859',
      '+1860',
      '+1862',
      '+1863',
      '+1864',
      '+1865',
      '+1870',
      '+1872',
      '+1878',
      '+1901',
      '+1903',
      '+1904',
      '+1906',
      '+1907',
      '+1908',
      '+1909',
      '+1910',
      '+1912',
      '+1913',
      '+1914',
      '+1915',
      '+1916',
      '+1917',
      '+1918',
      '+1919',
      '+1920',
      '+1925',
      '+1928',
      '+1929',
      '+1930',
      '+1931',
      '+1934',
      '+1936',
      '+1937',
      '+1938',
      '+1940',
      '+1941',
      '+1947',
      '+1949',
      '+1951',
      '+1952',
      '+1954',
      '+1956',
      '+1959',
      '+1970',
      '+1971',
      '+1972',
      '+1973',
      '+1975',
      '+1978',
      '+1979',
      '+1980',
      '+1984',
      '+1985',
      '+1989',
    ],
    nombre: 'United States',
    bandera: 'https://flagcdn.com/w320/us.png',
  },
  {
    codigo: 'SR',
    telefonos: ['+597'],
    nombre: 'Suriname',
    bandera: 'https://flagcdn.com/w320/sr.png',
  },
  {
    codigo: 'VA',
    telefonos: ['+3906698', '+379'],
    nombre: 'Vatican City',
    bandera: 'https://flagcdn.com/w320/va.png',
  },
  {
    codigo: 'PG',
    telefonos: ['+675'],
    nombre: 'Papua New Guinea',
    bandera: 'https://flagcdn.com/w320/pg.png',
  },
  {
    codigo: 'MW',
    telefonos: ['+265'],
    nombre: 'Malawi',
    bandera: 'https://flagcdn.com/w320/mw.png',
  },
  {
    codigo: 'HU',
    telefonos: ['+36'],
    nombre: 'Hungary',
    bandera: 'https://flagcdn.com/w320/hu.png',
  },
  {
    codigo: 'KH',
    telefonos: ['+855'],
    nombre: 'Cambodia',
    bandera: 'https://flagcdn.com/w320/kh.png',
  },
  {
    codigo: 'EC',
    telefonos: ['+593'],
    nombre: 'Ecuador',
    bandera: 'https://flagcdn.com/w320/ec.png',
  },
  {
    codigo: 'CA',
    telefonos: ['+1'],
    nombre: 'Canada',
    bandera: 'https://flagcdn.com/w320/ca.png',
  },
  {
    codigo: 'NO',
    telefonos: ['+47'],
    nombre: 'Norway',
    bandera: 'https://flagcdn.com/w320/no.png',
  },
  {
    codigo: 'ML',
    telefonos: ['+223'],
    nombre: 'Mali',
    bandera: 'https://flagcdn.com/w320/ml.png',
  },
  {
    codigo: 'WS',
    telefonos: ['+685'],
    nombre: 'Samoa',
    bandera: 'https://flagcdn.com/w320/ws.png',
  },
  {
    codigo: 'FJ',
    telefonos: ['+679'],
    nombre: 'Fiji',
    bandera: 'https://flagcdn.com/w320/fj.png',
  },
  {
    codigo: 'CO',
    telefonos: ['+57'],
    nombre: 'Colombia',
    bandera: 'https://flagcdn.com/w320/co.png',
  },
  {
    codigo: 'CU',
    telefonos: ['+53'],
    nombre: 'Cuba',
    bandera: 'https://flagcdn.com/w320/cu.png',
  },
  {
    codigo: 'TH',
    telefonos: ['+66'],
    nombre: 'Thailand',
    bandera: 'https://flagcdn.com/w320/th.png',
  },
  {
    codigo: 'MN',
    telefonos: ['+976'],
    nombre: 'Mongolia',
    bandera: 'https://flagcdn.com/w320/mn.png',
  },
  {
    codigo: 'GW',
    telefonos: ['+245'],
    nombre: 'Guinea-Bissau',
    bandera: 'https://flagcdn.com/w320/gw.png',
  },
  {
    codigo: 'AR',
    telefonos: ['+54'],
    nombre: 'Argentina',
    bandera: 'https://flagcdn.com/w320/ar.png',
  },
  {
    codigo: 'MX',
    telefonos: ['+52'],
    nombre: 'Mexico',
    bandera: 'https://flagcdn.com/w320/mx.png',
  },
  {
    codigo: 'TM',
    telefonos: ['+993'],
    nombre: 'Turkmenistan',
    bandera: 'https://flagcdn.com/w320/tm.png',
  },
  {
    codigo: 'ET',
    telefonos: ['+251'],
    nombre: 'Ethiopia',
    bandera: 'https://flagcdn.com/w320/et.png',
  },
  {
    codigo: 'GA',
    telefonos: ['+241'],
    nombre: 'Gabon',
    bandera: 'https://flagcdn.com/w320/ga.png',
  },
  {
    codigo: 'KR',
    telefonos: ['+82'],
    nombre: 'South Korea',
    bandera: 'https://flagcdn.com/w320/kr.png',
  },
  {
    codigo: 'TG',
    telefonos: ['+228'],
    nombre: 'Togo',
    bandera: 'https://flagcdn.com/w320/tg.png',
  },
  {
    codigo: 'GH',
    telefonos: ['+233'],
    nombre: 'Ghana',
    bandera: 'https://flagcdn.com/w320/gh.png',
  },
  {
    codigo: 'ZM',
    telefonos: ['+260'],
    nombre: 'Zambia',
    bandera: 'https://flagcdn.com/w320/zm.png',
  },
  {
    codigo: 'NZ',
    telefonos: ['+64'],
    nombre: 'New Zealand',
    bandera: 'https://flagcdn.com/w320/nz.png',
  },
  {
    codigo: 'LA',
    telefonos: ['+856'],
    nombre: 'Laos',
    bandera: 'https://flagcdn.com/w320/la.png',
  },
  {
    codigo: 'BI',
    telefonos: ['+257'],
    nombre: 'Burundi',
    bandera: 'https://flagcdn.com/w320/bi.png',
  },
  {
    codigo: 'PK',
    telefonos: ['+92'],
    nombre: 'Pakistan',
    bandera: 'https://flagcdn.com/w320/pk.png',
  },
  {
    codigo: 'AM',
    telefonos: ['+374'],
    nombre: 'Armenia',
    bandera: 'https://flagcdn.com/w320/am.png',
  },
  {
    codigo: 'CZ',
    telefonos: ['+420'],
    nombre: 'Czechia',
    bandera: 'https://flagcdn.com/w320/cz.png',
  },
  {
    codigo: 'SM',
    telefonos: ['+378'],
    nombre: 'San Marino',
    bandera: 'https://flagcdn.com/w320/sm.png',
  },
  {
    codigo: 'ST',
    telefonos: ['+239'],
    nombre: 'São Tomé and Príncipe',
    bandera: 'https://flagcdn.com/w320/st.png',
  },
  {
    codigo: 'BS',
    telefonos: ['+1242'],
    nombre: 'Bahamas',
    bandera: 'https://flagcdn.com/w320/bs.png',
  },
  {
    codigo: 'FI',
    telefonos: ['+358'],
    nombre: 'Finland',
    bandera: 'https://flagcdn.com/w320/fi.png',
  },
  {
    codigo: 'SL',
    telefonos: ['+232'],
    nombre: 'Sierra Leone',
    bandera: 'https://flagcdn.com/w320/sl.png',
  },
  {
    codigo: 'LU',
    telefonos: ['+352'],
    nombre: 'Luxembourg',
    bandera: 'https://flagcdn.com/w320/lu.png',
  },
  {
    codigo: 'TV',
    telefonos: ['+688'],
    nombre: 'Tuvalu',
    bandera: 'https://flagcdn.com/w320/tv.png',
  },
  {
    codigo: 'ER',
    telefonos: ['+291'],
    nombre: 'Eritrea',
    bandera: 'https://flagcdn.com/w320/er.png',
  },
  {
    codigo: 'SN',
    telefonos: ['+221'],
    nombre: 'Senegal',
    bandera: 'https://flagcdn.com/w320/sn.png',
  },
  {
    codigo: 'NP',
    telefonos: ['+977'],
    nombre: 'Nepal',
    bandera: 'https://flagcdn.com/w320/np.png',
  },
  {
    codigo: 'AG',
    telefonos: ['+1268'],
    nombre: 'Antigua and Barbuda',
    bandera: 'https://flagcdn.com/w320/ag.png',
  },
  {
    codigo: 'CV',
    telefonos: ['+238'],
    nombre: 'Cape Verde',
    bandera: 'https://flagcdn.com/w320/cv.png',
  },
  {
    codigo: 'BD',
    telefonos: ['+880'],
    nombre: 'Bangladesh',
    bandera: 'https://flagcdn.com/w320/bd.png',
  },
  {
    codigo: 'KG',
    telefonos: ['+996'],
    nombre: 'Kyrgyzstan',
    bandera: 'https://flagcdn.com/w320/kg.png',
  },
  {
    codigo: 'NG',
    telefonos: ['+234'],
    nombre: 'Nigeria',
    bandera: 'https://flagcdn.com/w320/ng.png',
  },
  {
    codigo: 'ES',
    telefonos: ['+34'],
    nombre: 'Spain',
    bandera: 'https://flagcdn.com/w320/es.png',
  },
  {
    codigo: 'MH',
    telefonos: ['+692'],
    nombre: 'Marshall Islands',
    bandera: 'https://flagcdn.com/w320/mh.png',
  },
  {
    codigo: 'QA',
    telefonos: ['+974'],
    nombre: 'Qatar',
    bandera: 'https://flagcdn.com/w320/qa.png',
  },
  {
    codigo: 'VE',
    telefonos: ['+58'],
    nombre: 'Venezuela',
    bandera: 'https://flagcdn.com/w320/ve.png',
  },
  {
    codigo: 'TN',
    telefonos: ['+216'],
    nombre: 'Tunisia',
    bandera: 'https://flagcdn.com/w320/tn.png',
  },
  {
    codigo: 'MC',
    telefonos: ['+377'],
    nombre: 'Monaco',
    bandera: 'https://flagcdn.com/w320/mc.png',
  },
  {
    codigo: 'CF',
    telefonos: ['+236'],
    nombre: 'Central African Republic',
    bandera: 'https://flagcdn.com/w320/cf.png',
  },
  {
    codigo: 'LV',
    telefonos: ['+371'],
    nombre: 'Latvia',
    bandera: 'https://flagcdn.com/w320/lv.png',
  },
  {
    codigo: 'UZ',
    telefonos: ['+998'],
    nombre: 'Uzbekistan',
    bandera: 'https://flagcdn.com/w320/uz.png',
  },
  {
    codigo: 'BR',
    telefonos: ['+55'],
    nombre: 'Brazil',
    bandera: 'https://flagcdn.com/w320/br.png',
  },
  {
    codigo: 'CY',
    telefonos: ['+357'],
    nombre: 'Cyprus',
    bandera: 'https://flagcdn.com/w320/cy.png',
  },
  {
    codigo: 'KP',
    telefonos: ['+850'],
    nombre: 'North Korea',
    bandera: 'https://flagcdn.com/w320/kp.png',
  },
  {
    codigo: 'DM',
    telefonos: ['+1767'],
    nombre: 'Dominica',
    bandera: 'https://flagcdn.com/w320/dm.png',
  },
  {
    codigo: 'BA',
    telefonos: ['+387'],
    nombre: 'Bosnia and Herzegovina',
    bandera: 'https://flagcdn.com/w320/ba.png',
  },
  {
    codigo: 'LK',
    telefonos: ['+94'],
    nombre: 'Sri Lanka',
    bandera: 'https://flagcdn.com/w320/lk.png',
  },
  {
    codigo: 'CG',
    telefonos: ['+242'],
    nombre: 'Republic of the Congo',
    bandera: 'https://flagcdn.com/w320/cg.png',
  },
  {
    codigo: 'IL',
    telefonos: ['+972'],
    nombre: 'Israel',
    bandera: 'https://flagcdn.com/w320/il.png',
  },
  {
    codigo: 'NA',
    telefonos: ['+264'],
    nombre: 'Namibia',
    bandera: 'https://flagcdn.com/w320/na.png',
  },
  {
    codigo: 'FM',
    telefonos: ['+691'],
    nombre: 'Micronesia',
    bandera: 'https://flagcdn.com/w320/fm.png',
  },
  {
    codigo: 'SS',
    telefonos: ['+211'],
    nombre: 'South Sudan',
    bandera: 'https://flagcdn.com/w320/ss.png',
  },
  {
    codigo: 'RW',
    telefonos: ['+250'],
    nombre: 'Rwanda',
    bandera: 'https://flagcdn.com/w320/rw.png',
  },
  {
    codigo: 'UG',
    telefonos: ['+256'],
    nombre: 'Uganda',
    bandera: 'https://flagcdn.com/w320/ug.png',
  },
  {
    codigo: 'PT',
    telefonos: ['+351'],
    nombre: 'Portugal',
    bandera: 'https://flagcdn.com/w320/pt.png',
  },
  {
    codigo: 'BO',
    telefonos: ['+591'],
    nombre: 'Bolivia',
    bandera: 'https://flagcdn.com/w320/bo.png',
  },
  {
    codigo: 'LS',
    telefonos: ['+266'],
    nombre: 'Lesotho',
    bandera: 'https://flagcdn.com/w320/ls.png',
  },
  {
    codigo: 'TD',
    telefonos: ['+235'],
    nombre: 'Chad',
    bandera: 'https://flagcdn.com/w320/td.png',
  },
  {
    codigo: 'LT',
    telefonos: ['+370'],
    nombre: 'Lithuania',
    bandera: 'https://flagcdn.com/w320/lt.png',
  },
  {
    codigo: 'ME',
    telefonos: ['+382'],
    nombre: 'Montenegro',
    bandera: 'https://flagcdn.com/w320/me.png',
  },
  {
    codigo: 'OM',
    telefonos: ['+968'],
    nombre: 'Oman',
    bandera: 'https://flagcdn.com/w320/om.png',
  },
  {
    codigo: 'SD',
    telefonos: ['+249'],
    nombre: 'Sudan',
    bandera: 'https://flagcdn.com/w320/sd.png',
  },
  {
    codigo: 'BN',
    telefonos: ['+673'],
    nombre: 'Brunei',
    bandera: 'https://flagcdn.com/w320/bn.png',
  },
  {
    codigo: 'CD',
    telefonos: ['+243'],
    nombre: 'DR Congo',
    bandera: 'https://flagcdn.com/w320/cd.png',
  },
  {
    codigo: 'GR',
    telefonos: ['+30'],
    nombre: 'Greece',
    bandera: 'https://flagcdn.com/w320/gr.png',
  },
  {
    codigo: 'AL',
    telefonos: ['+355'],
    nombre: 'Albania',
    bandera: 'https://flagcdn.com/w320/al.png',
  },
  {
    codigo: 'TZ',
    telefonos: ['+255'],
    nombre: 'Tanzania',
    bandera: 'https://flagcdn.com/w320/tz.png',
  },
  {
    codigo: 'GE',
    telefonos: ['+995'],
    nombre: 'Georgia',
    bandera: 'https://flagcdn.com/w320/ge.png',
  },
  {
    codigo: 'JP',
    telefonos: ['+81'],
    nombre: 'Japan',
    bandera: 'https://flagcdn.com/w320/jp.png',
  },
  {
    codigo: 'SA',
    telefonos: ['+966'],
    nombre: 'Saudi Arabia',
    bandera: 'https://flagcdn.com/w320/sa.png',
  },
  {
    codigo: 'HR',
    telefonos: ['+385'],
    nombre: 'Croatia',
    bandera: 'https://flagcdn.com/w320/hr.png',
  },
  {
    codigo: 'SB',
    telefonos: ['+677'],
    nombre: 'Solomon Islands',
    bandera: 'https://flagcdn.com/w320/sb.png',
  },
  {
    codigo: 'YE',
    telefonos: ['+967'],
    nombre: 'Yemen',
    bandera: 'https://flagcdn.com/w320/ye.png',
  },
  {
    codigo: 'SO',
    telefonos: ['+252'],
    nombre: 'Somalia',
    bandera: 'https://flagcdn.com/w320/so.png',
  },
  {
    codigo: 'GD',
    telefonos: ['+1473'],
    nombre: 'Grenada',
    bandera: 'https://flagcdn.com/w320/gd.png',
  },
  {
    codigo: 'TO',
    telefonos: ['+676'],
    nombre: 'Tonga',
    bandera: 'https://flagcdn.com/w320/to.png',
  },
  {
    codigo: 'NI',
    telefonos: ['+505'],
    nombre: 'Nicaragua',
    bandera: 'https://flagcdn.com/w320/ni.png',
  },
  {
    codigo: 'PY',
    telefonos: ['+595'],
    nombre: 'Paraguay',
    bandera: 'https://flagcdn.com/w320/py.png',
  },
  {
    codigo: 'IN',
    telefonos: ['+91'],
    nombre: 'India',
    bandera: 'https://flagcdn.com/w320/in.png',
  },
  {
    codigo: 'GB',
    telefonos: ['+44'],
    nombre: 'United Kingdom',
    bandera: 'https://flagcdn.com/w320/gb.png',
  },
  {
    codigo: 'SZ',
    telefonos: ['+268'],
    nombre: 'Eswatini',
    bandera: 'https://flagcdn.com/w320/sz.png',
  },
  {
    codigo: 'MG',
    telefonos: ['+261'],
    nombre: 'Madagascar',
    bandera: 'https://flagcdn.com/w320/mg.png',
  },
  {
    codigo: 'GQ',
    telefonos: ['+240'],
    nombre: 'Equatorial Guinea',
    bandera: 'https://flagcdn.com/w320/gq.png',
  },
  {
    codigo: 'JO',
    telefonos: ['+962'],
    nombre: 'Jordan',
    bandera: 'https://flagcdn.com/w320/jo.png',
  },
  {
    codigo: 'BY',
    telefonos: ['+375'],
    nombre: 'Belarus',
    bandera: 'https://flagcdn.com/w320/by.png',
  },
  {
    codigo: 'MV',
    telefonos: ['+960'],
    nombre: 'Maldives',
    bandera: 'https://flagcdn.com/w320/mv.png',
  },
  {
    codigo: 'TL',
    telefonos: ['+670'],
    nombre: 'Timor-Leste',
    bandera: 'https://flagcdn.com/w320/tl.png',
  },
  {
    codigo: 'RS',
    telefonos: ['+381'],
    nombre: 'Serbia',
    bandera: 'https://flagcdn.com/w320/rs.png',
  },
  {
    codigo: 'IE',
    telefonos: ['+353'],
    nombre: 'Ireland',
    bandera: 'https://flagcdn.com/w320/ie.png',
  },
  {
    codigo: 'CL',
    telefonos: ['+56'],
    nombre: 'Chile',
    bandera: 'https://flagcdn.com/w320/cl.png',
  },
  {
    codigo: 'IQ',
    telefonos: ['+964'],
    nombre: 'Iraq',
    bandera: 'https://flagcdn.com/w320/iq.png',
  },
  {
    codigo: 'PH',
    telefonos: ['+63'],
    nombre: 'Philippines',
    bandera: 'https://flagcdn.com/w320/ph.png',
  },
  {
    codigo: 'ZA',
    telefonos: ['+27'],
    nombre: 'South Africa',
    bandera: 'https://flagcdn.com/w320/za.png',
  },
  {
    codigo: 'BJ',
    telefonos: ['+229'],
    nombre: 'Benin',
    bandera: 'https://flagcdn.com/w320/bj.png',
  },
  {
    codigo: 'BG',
    telefonos: ['+359'],
    nombre: 'Bulgaria',
    bandera: 'https://flagcdn.com/w320/bg.png',
  },
  {
    codigo: 'ID',
    telefonos: ['+62'],
    nombre: 'Indonesia',
    bandera: 'https://flagcdn.com/w320/id.png',
  },
  {
    codigo: 'MR',
    telefonos: ['+222'],
    nombre: 'Mauritania',
    bandera: 'https://flagcdn.com/w320/mr.png',
  },
  {
    codigo: 'SC',
    telefonos: ['+248'],
    nombre: 'Seychelles',
    bandera: 'https://flagcdn.com/w320/sc.png',
  },
  {
    codigo: 'RO',
    telefonos: ['+40'],
    nombre: 'Romania',
    bandera: 'https://flagcdn.com/w320/ro.png',
  },
  {
    codigo: 'TR',
    telefonos: ['+90'],
    nombre: 'Turkey',
    bandera: 'https://flagcdn.com/w320/tr.png',
  },
  {
    codigo: 'BF',
    telefonos: ['+226'],
    nombre: 'Burkina Faso',
    bandera: 'https://flagcdn.com/w320/bf.png',
  },
  {
    codigo: 'EG',
    telefonos: ['+20'],
    nombre: 'Egypt',
    bandera: 'https://flagcdn.com/w320/eg.png',
  },
  {
    codigo: 'VN',
    telefonos: ['+84'],
    nombre: 'Vietnam',
    bandera: 'https://flagcdn.com/w320/vn.png',
  },
  {
    codigo: 'TT',
    telefonos: ['+1868'],
    nombre: 'Trinidad and Tobago',
    bandera: 'https://flagcdn.com/w320/tt.png',
  },
  {
    codigo: 'AO',
    telefonos: ['+244'],
    nombre: 'Angola',
    bandera: 'https://flagcdn.com/w320/ao.png',
  },
  {
    codigo: 'CN',
    telefonos: ['+86'],
    nombre: 'China',
    bandera: 'https://flagcdn.com/w320/cn.png',
  },
  {
    codigo: 'UY',
    telefonos: ['+598'],
    nombre: 'Uruguay',
    bandera: 'https://flagcdn.com/w320/uy.png',
  },
  {
    codigo: 'MA',
    telefonos: ['+212'],
    nombre: 'Morocco',
    bandera: 'https://flagcdn.com/w320/ma.png',
  },
  {
    codigo: 'EE',
    telefonos: ['+372'],
    nombre: 'Estonia',
    bandera: 'https://flagcdn.com/w320/ee.png',
  },
  {
    codigo: 'LC',
    telefonos: ['+1758'],
    nombre: 'Saint Lucia',
    bandera: 'https://flagcdn.com/w320/lc.png',
  },
  {
    codigo: 'HT',
    telefonos: ['+509'],
    nombre: 'Haiti',
    bandera: 'https://flagcdn.com/w320/ht.png',
  },
  {
    codigo: 'TJ',
    telefonos: ['+992'],
    nombre: 'Tajikistan',
    bandera: 'https://flagcdn.com/w320/tj.png',
  },
  {
    codigo: 'NE',
    telefonos: ['+227'],
    nombre: 'Niger',
    bandera: 'https://flagcdn.com/w320/ne.png',
  },
  {
    codigo: 'LB',
    telefonos: ['+961'],
    nombre: 'Lebanon',
    bandera: 'https://flagcdn.com/w320/lb.png',
  },
  {
    codigo: 'AU',
    telefonos: ['+61'],
    nombre: 'Australia',
    bandera: 'https://flagcdn.com/w320/au.png',
  },
  {
    codigo: 'LR',
    telefonos: ['+231'],
    nombre: 'Liberia',
    bandera: 'https://flagcdn.com/w320/lr.png',
  },
  {
    codigo: 'IT',
    telefonos: ['+39'],
    nombre: 'Italy',
    bandera: 'https://flagcdn.com/w320/it.png',
  },
  {
    codigo: 'NR',
    telefonos: ['+674'],
    nombre: 'Nauru',
    bandera: 'https://flagcdn.com/w320/nr.png',
  },
  {
    codigo: 'CH',
    telefonos: ['+41'],
    nombre: 'Switzerland',
    bandera: 'https://flagcdn.com/w320/ch.png',
  },
  {
    codigo: 'PE',
    telefonos: ['+51'],
    nombre: 'Peru',
    bandera: 'https://flagcdn.com/w320/pe.png',
  },
  {
    codigo: 'LY',
    telefonos: ['+218'],
    nombre: 'Libya',
    bandera: 'https://flagcdn.com/w320/ly.png',
  },
  {
    codigo: 'DE',
    telefonos: ['+49'],
    nombre: 'Germany',
    bandera: 'https://flagcdn.com/w320/de.png',
  },
  {
    codigo: 'XK',
    telefonos: ['+383'],
    nombre: 'Kosovo',
    bandera: 'https://flagcdn.com/w320/xk.png',
  },
  {
    codigo: 'BH',
    telefonos: ['+973'],
    nombre: 'Bahrain',
    bandera: 'https://flagcdn.com/w320/bh.png',
  },
  {
    codigo: 'IR',
    telefonos: ['+98'],
    nombre: 'Iran',
    bandera: 'https://flagcdn.com/w320/ir.png',
  },
  {
    codigo: 'SY',
    telefonos: ['+963'],
    nombre: 'Syria',
    bandera: 'https://flagcdn.com/w320/sy.png',
  },
  {
    codigo: 'KN',
    telefonos: ['+1869'],
    nombre: 'Saint Kitts and Nevis',
    bandera: 'https://flagcdn.com/w320/kn.png',
  },
  {
    codigo: 'GM',
    telefonos: ['+220'],
    nombre: 'Gambia',
    bandera: 'https://flagcdn.com/w320/gm.png',
  },
  {
    codigo: 'NL',
    telefonos: ['+31'],
    nombre: 'Netherlands',
    bandera: 'https://flagcdn.com/w320/nl.png',
  },
  {
    codigo: 'CI',
    telefonos: ['+225'],
    nombre: 'Ivory Coast',
    bandera: 'https://flagcdn.com/w320/ci.png',
  },
  {
    codigo: 'KI',
    telefonos: ['+686'],
    nombre: 'Kiribati',
    bandera: 'https://flagcdn.com/w320/ki.png',
  },
  {
    codigo: 'PW',
    telefonos: ['+680'],
    nombre: 'Palau',
    bandera: 'https://flagcdn.com/w320/pw.png',
  },
  {
    codigo: 'VC',
    telefonos: ['+1784'],
    nombre: 'Saint Vincent and the Grenadines',
    bandera: 'https://flagcdn.com/w320/vc.png',
  },
  {
    codigo: 'PL',
    telefonos: ['+48'],
    nombre: 'Poland',
    bandera: 'https://flagcdn.com/w320/pl.png',
  },
  {
    codigo: 'BB',
    telefonos: ['+1246'],
    nombre: 'Barbados',
    bandera: 'https://flagcdn.com/w320/bb.png',
  },
  {
    codigo: 'ZW',
    telefonos: ['+263'],
    nombre: 'Zimbabwe',
    bandera: 'https://flagcdn.com/w320/zw.png',
  },
  {
    codigo: 'SE',
    telefonos: ['+46'],
    nombre: 'Sweden',
    bandera: 'https://flagcdn.com/w320/se.png',
  },
  {
    codigo: 'DO',
    telefonos: ['+1809', '+1829', '+1849'],
    nombre: 'Dominican Republic',
    bandera: 'https://flagcdn.com/w320/do.png',
  },
  {
    codigo: 'BE',
    telefonos: ['+32'],
    nombre: 'Belgium',
    bandera: 'https://flagcdn.com/w320/be.png',
  },
  {
    codigo: 'MZ',
    telefonos: ['+258'],
    nombre: 'Mozambique',
    bandera: 'https://flagcdn.com/w320/mz.png',
  },
  {
    codigo: 'MU',
    telefonos: ['+230'],
    nombre: 'Mauritius',
    bandera: 'https://flagcdn.com/w320/mu.png',
  },
  {
    codigo: 'AZ',
    telefonos: ['+994'],
    nombre: 'Azerbaijan',
    bandera: 'https://flagcdn.com/w320/az.png',
  },
];
